
/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require('./bootstrap');

$('.dropdown-toggle').dropdown();

// Pace often sticks at 99%, possibly related to our web sockets. Also a bug on Safari.
// This is a workaround. Modified to run every 0.5 seconds not every 0.1 and time out
// after 2.5 seconds (not 5).
// https://stackoverflow.com/questions/43887415/pace-js-never-reaches-100
var initDestroyTimeOutPace = function() {
    var counter = 0;

    var refreshIntervalId = setInterval( function(){
        var progress;

        if( typeof $( '.pace-progress' ).attr( 'data-progress-text' ) !== 'undefined' ) {
            progress = Number( $( '.pace-progress' ).attr( 'data-progress-text' ).replace("%" ,'') );
        }

        if( progress === 99 ) {
            counter++;
        }

        if( counter > 5 ) {
            clearInterval(refreshIntervalId);
            Pace.stop();
        }
    }, 500);
}
initDestroyTimeOutPace();

window.app = {
    /**
     * Give us a function to set/change the page print size.
     * Based on: https://stackoverflow.com/questions/11160260/can-javascript-change-the-value-of-page-css
     * Call it like this: window.app.setPrintPageSize('a4', 'landscape');
     */
    setPrintPageSize: (function () {
        var style = document.createElement('style');
        style.id = 'app-print-styles';
        document.head.appendChild(style);

        return function (size, orientation) {
            if (orientation === false) {
                style.innerHTML = '';
            }
            if (orientation === undefined) {
                orientation = 'portrait';
            }

            // If size was passed as false, remove everything.
            if (size === false) {
                document.getElementsByTagName('body')[0].classList.remove('print-portrait');
                document.getElementsByTagName('body')[0].classList.remove('print-landscape');
                document.getElementsByTagName('body')[0].classList.remove('print-a4');
                document.getElementsByTagName('body')[0].classList.remove('print-a3');
                return;
            }
            // Remove case sensitivity
            orientation = orientation.toLowerCase();
            size = size.toLowerCase();

            // Check only valid options have been given
            if (['a4', 'a3'].indexOf(size) < 0) {
                console.log('Invalid page size given to setPrintPageSize: ' + size);
                return;
            }
            // Check only valid options have been given
            if (['landscape', 'portrait'].indexOf(orientation) < 0) {
                console.log('Invalid page orientation given to setPrintPageSize: ' + orientation);
                return;
            }

            // Toggle classes on the body based on the given settings. Most of our
            // CSS will be based on these, we just can't set @page conditionally.
            document.getElementsByTagName('body')[0].classList.toggle('print-portrait', orientation === 'portrait');
            document.getElementsByTagName('body')[0].classList.toggle('print-landscape', orientation === 'landscape');
            document.getElementsByTagName('body')[0].classList.toggle('print-a4', size === 'a4');
            document.getElementsByTagName('body')[0].classList.toggle('print-a3', size === 'a3');

            // And finally fill in the actual <style> element.
            style.innerHTML = `@page { size: ${size} ${orientation}; }`;
        };
    })()
}

require('./_validate.js');

// Generic object for working with Polygons.
require('./common/_maps.js');
require('./common/_polygons.js');
require('./common/_lightbox.js');

// Drive-dashboard specific bits
require('./drive-dashboard/_dashboard.js');
require('./drive-dashboard/_map-legend.js');
require('./drive-dashboard/_livewire_laravel_event_bridge.js');
require('./drive-dashboard/_map.js');
require('./drive-dashboard/_drives.js');
require('./drive-dashboard/_drive-list.js');
require('./drive-dashboard/_area-list.js');
require('./drive-dashboard/_print.js');
require('./drive-dashboard/_tracking-switcher.js');

// Pages related to editing polygons (Areas and Subdivisions)
require('./edit-polygon/_edit-subdivisions.js');
